app.ui.registerUi('toast', function (app) {
    var helpers = app.helpers.funcs;
    return {
        lastAddedAt: new Date(),
        timeThreshold: 500,
        closeMessage: 'Got it',
		implementationExists: function() {
			return jQuery.fn.toastr ? true : false;
		},
        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },
		init: function ($scope) {
		    toastr.options.closeButton = true;
		    toastr.options.progressBar = false;
		    toastr.options.positionClass = this.getPositionClass();
		    toastr.options.timeOut = 10000;
		},
		setCloseHtml: function(msg) {
		    toastr.options.closeHtml = this.getCloseHtml(msg);
		},
		getCloseHtml: function(msg) {
		    msg = typeof msg !== 'undefined' ? msg : this.closeMessage;
		    return '<div class="close-wrap"><button aria-hidden="true" class="toast-close-button" type="button"><span class="text">' + msg + '</span> <span class="glyph">&times;</span></button></div>'
		},
		getPositionClass: function() {
		    return 'toast-bottom-full-width';
		},
		fireWithTitle: function (title, message, type, options) {
            options = typeof options !== 'undefined' ? options : {};
            var ariaHidden = false;
            if (typeof options === 'string' || options instanceof String) {
                var localCloseMessage = options;
                var id = null;
                var errorCode = null;
            } else {
                var localCloseMessage = options.localCloseMessage;
                var id = options.id;
                var errorCode = options.errorCode;
                if (options.ariaHidden) {
                    ariaHidden = true;
                }
            }

            // Set close message
            this.setCloseHtml(localCloseMessage);

            // Translate type from danger to error, if danger was given
            type = typeof type !== 'undefined' && (type !== null) ? type : 'info';
            if (type == 'danger') type = 'error';

            // Fire toast!
            var $toastElem;
            if (title) {
                toastr.options.positionClass = this.getPositionClass() + ' toast-with-title';
                $toastElem = toastr[type](title, message);
            } else {
                toastr.options.positionClass = this.getPositionClass() + ' toast-without-title';
                $toastElem = toastr[type](message);
            }

            // Customise inner HTML
            var openingTag = '<div class="container"';
            if (id) openingTag += ' id="' + id + '"';
            if (errorCode) openingTag += ' data-error-code="' + errorCode + '"';
            if (ariaHidden) openingTag += ' aria-hidden="true"';
            openingTag += '>'
            $toastElem.wrapInner(openingTag + '<div class="row"><div class="col-sm-12"><div class="toast-table"></div></div></div></div>');

            // Return close message back to default
            toastr.options.closeHtml = this.getCloseHtml();
            this.lastAddedAt = new Date();
        },
        fire: function (message, type, options) {
            return this.fireWithTitle(null, message, type, options);
            scope.lastAddedAt = new Date();
        },
        fireScreenReaderOnly: function (message, priority) {
            var scope = this;
            var now = new Date();
            var lastMilli = scope.lastAddedAt.getTime();
            var nowMilli = now.getTime();
            if (lastMilli + scope.timeThreshold > nowMilli) return;
            priority = typeof priority !== 'undefined' ? priority : 'assertive';
            var $elem = $('<p class="sr-only" role="alert">' + message + '</p>');
            $elem.prependTo($('body'));
            setTimeout(function () {
                $elem.remove();
            }, 10000);
            scope.lastAddedAt = now;
        }
    };
});
